import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/dues/"
)({
  component: () => (
    <Navigate to="/finance/dues/$tabKey" params={{ tabKey: "dashboard" }} />
  ),
})
